import { mergeSceneTracks } from './utiles/scene'
import { getSceneSegments, isSegmentVideo } from './utiles'
import { getEndHotAreaNodeGroupUuid } from '../brain/brain'
import { IvPreviewState } from './enums'

function getInitState() {
  return {
    // 当前光标（帧）
    currentFrame: -1,
    timelineData: [],
    previewState: IvPreviewState.Pause, // 时间轴播放状态
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  mutations: {
    updateCurrentFrame(state, value) {
      state.currentFrame = value
    },
    updateTimelineData(state, data) {
      state.timelineData = data
    },
    updatePreviewState(state, data) {
      state.previewState = data
    },
  },

  actions: {
    refreshTimeline({ state, dispatch, rootGetters }) {
      const uuids = rootGetters['ivBrain/brainBranchUuids'] || []

      state.timelineData = mergeSceneTracks(uuids)

      dispatch('refreshTimelineSelected')
    },
    refreshTimelineSelected({ state, rootState }) {
      const activeNode = rootState.workspace.game.activeNode
      const id = activeNode ? activeNode.uuid : ''

      const currentSceneNode = rootState.workspace.sceneManager.currentSceneNode
      const currentSceneNodeId = currentSceneNode
        ? currentSceneNode.uuid
        : undefined

      const sceneSegments = currentSceneNodeId
        ? getSceneSegments(currentSceneNodeId, state.timelineData)
        : []
      const videoSegment = sceneSegments.find(isSegmentVideo)

      const activeId =
        videoSegment && (!videoSegment.asset || videoSegment.isEnd)
          ? videoSegment.id
          : id

      const realSegmentId = getEndHotAreaNodeGroupUuid(activeId) || activeId
      state.timelineData.forEach((t) => {
        t.segments.forEach((s) => {
          s.selected = s.id === realSegmentId
        })
      })
    },
  },
}
